import { pagination } from "../../pagination";
import { product_search_product } from "./product_search_product";

export class product_search {
  public error_information: string = "";
  public pagination: pagination = new pagination();
  public products: product_search_product[] = [];
}
